import { Component } from '@angular/core';

@Component({
    selector: 'app-anonymize',
    templateUrl: './anonymize.component.html',
    styleUrls: ['./anonymize.component.scss'],
    standalone: false
})
export class AnonymizeComponent {

}
